import { lazy } from "react";
import Loadable from "app/components/Loadable";

const NotFound = Loadable(lazy(() => import("./NotFound")));
const NotAuthorized = Loadable(lazy(() => import("./NotAuthorized")));
const ForgotPassword = Loadable(lazy(() => import("./ForgotPassword")));

const FirebaseLogin = Loadable(lazy(() => import("./login/FirebaseLogin")));
const FirebaseRegister = Loadable(lazy(() => import("./register/FirebaseRegister")));

const sessionRoutes = [
  { path: "/session/signup", element: <FirebaseRegister /> },
  { path: "/session/signin", element: <FirebaseLogin /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "*", element: <NotFound /> },
  { path: "not-authorized", element: <NotAuthorized /> }
];

export default sessionRoutes;
